import { Space } from '@databases/types/confluence';

import { SpaceInfo } from '../../confluence/space';
import { AsyncOperation, AsyncOperationStatus } from '../redux';

import { ContextAppState } from './actions';

export function selectSpaceInfoStatus(
  state: ContextAppState,
  { spaceKey }: { spaceKey: string }
): AsyncOperation<void> | undefined {
  return state.spaces.spaceInfoStatus[spaceKey];
}

export function selectSpaceInfo(
  state: ContextAppState,
  { spaceKey }: { spaceKey: string }
): SpaceInfo | undefined {
  if (selectSpaceInfoStatus(state, { spaceKey })?.status === AsyncOperationStatus.ERROR) {
    return undefined;
  }
  return state.spaces.spaceInfo[spaceKey];
}

export function selectSpacesStatus(
  state: ContextAppState
): AsyncOperation<void> | undefined {
  return state.spaces.spacesStatus;
}

export function selectSpaces(state: ContextAppState): Space[] | undefined {
  if (selectSpacesStatus(state)?.status === AsyncOperationStatus.ERROR) {
    return undefined;
  }
  return state.spaces.spaces;
}
